import { render, staticRenderFns } from "./CompanyDirectoryComponent.vue?vue&type=template&id=37a80e41&scoped=true"
import script from "./CompanyDirectoryComponent.vue?vue&type=script&lang=js"
export * from "./CompanyDirectoryComponent.vue?vue&type=script&lang=js"
import "./CompanyDirectoryComponent.vue?vue&type=style&index=0&id=37a80e41&prod&scoped=true&lang=css"
import "./CompanyDirectoryComponent.vue?vue&type=style&index=1&id=37a80e41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a80e41",
  null
  
)

export default component.exports